import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const formatMoney = (v) =>
  v != null
    ? Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '0,00';

const ModalConfirmacaoLancar = ({
  show,
  onClose,
  onConfirm,
  titulos,
  titulosAlterados,
  taxa,
  tipoTaxa,
  loading,
}) => {
  const titulosAlteradosList = titulos.filter(
    (t) => titulosAlterados[t.codigo_titulo] && titulosAlterados[t.codigo_titulo] !== t.data_vencimento,
  );

  const deltaLiquidoTotal = titulosAlteradosList.reduce((acc, t) => acc + (Number(t.liquido) || 0), 0);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Atualização de Vencimento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você está prestes a alterar{' '}
          <strong>{titulosAlteradosList.length} título(s)</strong>.
        </p>
        <ul>
          <li>
            <strong>Líquido total:</strong> R$ {formatMoney(deltaLiquidoTotal)}
          </li>
          <li>
            <strong>Taxa aplicada:</strong> {taxa != null ? Number(taxa).toFixed(4) : '0,0000'}%
            ({tipoTaxa === 'F' ? 'Juros compostos' : 'Desconto simples'})
          </li>
        </ul>
        <p className="text-danger">
          <strong>Esta operação é irreversível.</strong> Continuar?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="success" onClick={onConfirm} disabled={loading}>
          {loading ? 'Processando...' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacaoLancar;
